module.exports = __webpack_public_path__ + "img/ceiling.10b78857.jpg";